module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 68300.371b0f8e.png";